<!--历史值-->
<template>
	<div class="historyAnalysisBody">
		<!--左边-->
		<elRadioTree slot="tree" :dataList='virtualDeviceList'></elRadioTree>
		<!--右边-->
		<div class="monreportRigth" slot="body">
			<div class="buttonLine">
				<label>应用类型组：</label>
                <!-- multiple collapse-tags :multiple-limit="1" -->
				<el-select v-model="apptypeValue"  placeholder="请选择" size='small'>
					<!-- <el-option label='全选' value='全选' @click.native='selectAll'></el-option> -->
					<el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<timeintervalselection style="margin-left: .1rem;" @selectInterval="selectInterval" defaultInterval="30"></timeintervalselection>
				<label style="margin-left:10px;">日期：</label>
				<el-date-picker value-format="timestamp" size="small" v-model="datetimeValue" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				<iconButton @buttonClick='searchHistory' buttonText='查看' icoName="wedoButton/search.png"></iconButton>
			</div>
			<!--图表-->
			<vchart style="height: calc(100% - 120px);" ref='vchart'></vchart>
		</div>
	</div>
</template>

<script type="text/javascript">
	import iconButton from '@/components/module/universal/iconButton.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import timeintervalselection from '@/components/module/selection/timeIntervalSelection.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			iconButton,
			multipleSelection,
			timeintervalselection,
			vchart,
			elRadioTree,
		},
		props: [],
		data() {
			return {
				// nowDevice: {}, //当前选中设备列表
				nowApptypeGroups: [], //当前选中的应用类型组
				bgDate: new Date(new Date().formatByDate()),
				endDate: new Date(),
				checkVariablename: [], //需要显示的变量名称
				timeInterval: 30, //时间间隔,单位是分钟
				// nowSeries: [],
				options: {},
				from2name: {},
				count: 0,
				apptypeValue: "",
				datetimeValue: [new Date(new Date().toLocaleDateString()).getTime(), new Date().getTime()],
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					 shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date(new Date().toLocaleDateString());
							const start = new Date(new Date().toLocaleDateString());
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date(new Date().toLocaleDateString());
							const start = new Date(new Date().toLocaleDateString());
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.xAxis = {
				type: 'time',
				splitLine: {
					show: false,
					lineStyle: {
						width: .5,
						type: 'solid'
					}
				},
			}
			this.options.yAxis = {
				lineStyle: {
					show: false,
					width: 1,
					type: 'solid',
				}
			}
			this.options.toolbox['iconStyle'] = {
				'color': 'white',
				'borderColor': 'white',
				'shadowColor': 'white'
			}
			this.options.tooltip = {
				trigger: 'axis',
				confine: true,
				formatter(params, ticket, callback) {
					var label = new Date(params[0].data[0]).formatByTime() + "</br>";
					params.forEach(item => {
						var values;
						if (isnull(item.data[1])) {
							values = "无采集数据";
						} else {
							values = cutDigital(item.data[1]);
						}
						label += item.seriesName + " : " + values + "</br>"
					})
					return label;
				},
				axisPointer: {
					animation: false
				}
			}
			this.options.dataZoom = [{
					type: 'slider',
					show: true,
					start: 0,
					end: 100,
					handleSize: 8
				},
				{
					type: 'inside',
					start: 0,
					end: 100
				}
			]
			this.$refs.vchart.setData(this.options, true)
			this.apptypeValue = this.nowSelectAppTypeGroupIds[0]
			setTimeout(() => {
				this.searchHistory()
			}, 300)
		},
		destroyed() {},
		computed: {
			nowSelectAppTypeGroupIds() {
				return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
			},
			nowDevice() {
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			getReadDeviceTree() {
				return [this.deviceStore.getters.getReadDeviceTree]
			},
			variableStore() {
				return this.$store.variableStore
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			deviceStore() {
				return this.$store.deviceStore
			},
			deviceTree() {
				return [this.deviceStore.getters.getReadDeviceTree]
			},
			variableTree() {
				if (isempty(this.nowDevice)) {
					return []
				}
				return this.variableStore.getters.getVariableTree(this.nowDevice.no)
			},
			apptypeGroups() {
				//所有已选中的设备所具有的变量类型组
				var list = []
				var apptypeGroupIds = []
				this.variableTree.forEach(apptypeGroup => {
					if (!apptypeGroupIds.includes(apptypeGroup.id)) {
						apptypeGroupIds.push(apptypeGroup.id)
						list.push(apptypeGroup)
					}
				})
				//排序
				return list.sort((a, b) => {
					return a.serialnum - b.serialnum
				})
			},
			apptypes() {
				//当前选中的这些变量类型组下面的变量类型列表
				var list = []
				this.apptypeGroups.forEach(item => {
					list = list.concat(this.variableStore.getters.getApptypeByGroupId(item.id))
				})
				return list
			},
			columns() {
				var list = []
				list.push({
					name: "时间",
					key: 'time',
					format(value) {
						return new Date(value).formatByTime()
					}
				})
				this.nowVariableNames.forEach(item => {
					list.push({
						name: item.substr(item.indexOf(".") + 1),
						key: item
					})
				})
				return list
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				var ag = this.nowApptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if (isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						this.from2name[i.fromName] = i.name
						v2.push(i.fromName) //name !=  fromName
					})
				})
				return v2
			},
			timeObject() {
				//时间列表,根据开始结束时间和时间间隔计算
				/* var start = this.bgDate.getTime()
				var end = this.endDate.getTime() + 24 * 60 * 60 * 1000 */
				var start = this.datetimeValue[0]
				var end = this.datetimeValue[1] + 24 * 60 * 60 * 1000
				var obj = {}
				while (start < end) {
					obj[start] = 0
					start += this.timeInterval * 60 * 1000
				}
				return obj
			},
			nowSeries() {
				if (isempty(this.variableTree)) {
					return []
				} else {
					var fromnameList = []
					this.variableTree.forEach(item => {
						item.next.forEach(i => {
							fromnameList.push(i.fromName)
						})
					})
					var list = []
					fromnameList.forEach(item => {
						var name = this.from2name[item] ? this.from2name[item] : item
						name = name.subByFirstChar(".")
						list.push({
							name: name,
							fromName: item,
							type: 'line',
							smooth: true,
							markPoint: {
								data: [{
										name: '最大值',
										formatter: "{b}:{c}",
										type: 'max'
									},
									{
										name: '最小值',
										formatter: "{b}:{c}",
										type: 'min'
									}
								]
							},
							symbol: 'emptyCircle',
							symbolSize: 20,
							sampling: 'average',
							data: [],
						})
					})
					return list
				}

			}
		},
		watch: {
			datetimeValue(){
				this.searchHistory()
			},
			nowDevice(nv, ov) {
				this.timeToValue = {}
				this.searchHistory()
			},
			timeObject(nv, ov) {
				this.setSeries(this.timeObject)
			},
			apptypeValue(item, ov) {
                var nv = [item]
                console.log("选中的值",nv);

				this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', nv)
				let list = []
				if(!isempty(nv)) {
					nv.forEach(item => {
						this.apptypeGroups.forEach(item2 => {
							if(item == item2.id) {
								list.push(item2)
							}
						})
					})
				}
				this.nowApptypeGroups = list
				this.searchHistory()
			}
		},
		methods: {
			selectAll() {
				//全选 先判断是否有选中的，有选中就清空
				if(this.apptypeValue.length==1) {
					this.nowApptypeGroup = this.apptypeGroups
					let idList = []
					this.apptypeGroups.forEach(item => {
						idList.push(item.id)
					})
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', idList)
					this.apptypeValue = idList
				}else{
					this.nowApptypeGroup =[]
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', [])
					this.apptypeValue=[]
				}
			},
			/* autoSelectMethod(item, index) {
				if (this.nowDevice != undefined) {
					return this.nowDevice.id == item.id && this.nowDevice.type == item.type
				} else {
					return item.type == 'virtualDevice'
				}
			},
			checkDevice(data) {
				// this.nowDevice = data
				this.$store.deviceStore.commit('setNowVirtualDevice', data)
			}, */
			searchHistory() {
				/* if (this.bgDate.getTime() > this.endDate.getTime()) {
					this.$dialogMethod.showMessage("开始时间不能大于结束时间!")
					return
				}
				if (this.endDate.getTime() - this.bgDate.getTime() >= 90 * 24 * 60 * 60 * 1000) {
					this.$dialogMethod.showMessage("时间跨度请勿超过90天!")
					return
				} */
				if (this.datetimeValue[1] - this.datetimeValue[0] >= 90 * 24 * 60 * 60 * 1000) {
					this.$message({
						message: '时间跨度请勿超过90天',
						type: 'warning'
					})
					return
				}
				if (isempty(this.nowSeries)) { // 防止series undefiend
					setTimeout(() => {
						if (this.count < 10) {
							this.searchHistory()
							this.count++
						}
					}, 100)
					return
				}
				this.count = 0
				var values = historyValues()
                var d = "10"
				//查询数据
				this.$dialogMethod.showLoading("正在查询数据...")
				this.$api.historyApi.searchDeviceHistory(d, this.datetimeValue[0], this.datetimeValue[1], respon => {
					//清空当前数据
					var nowSeries = this.nowSeries
					for (var i = 0, len = nowSeries.length; i < len; i++) {
						nowSeries[i].data.clear()
					}
					this.$dialogMethod.showLoading("正在加载...")
					//把历史值数据放到数据列中
					for (var i = 0, len = respon.length; i < len; i++) {
						var item = respon[i]
						for (var i1 = 0, len1 = item.next.length; i1 < len1; i1++) {
							var year = item.next[i1]
							for (var i2 = 0, len2 = year.next.length; i2 < len2; i2++) {
								var month = year.next[i2]
								var monthNext = month.next
								for (var i3 = 0, len3 = monthNext.length; i3 < len3; i3++) {
									var day = monthNext[i3]
									var dayNext = day.next
									for (var i4 = 0, len4 = dayNext.length; i4 < len4; i4++) {
										//具体数据列
										var data = dayNext[i4]
										var values = data.data
										var variablename = data.variablename
										var nowDateTime = new Date(year.name + "/" + month.name + "/" + day.name).getTime()
										var series = nowSeries.find(s => {
											return s.fromName == variablename //必须为 fromName
										})
										if (series == null) {
											continue
										}
										var nValues = values.map((value, index) => {
											return [nowDateTime + index * 5 * 60 * 1000, value]
										})
										if (series.data != undefined) {
											series.data = series.data.concat(nValues)
										} else {
											series.data = nValues
										}
									}

								}
							}
						}
					}
					this.setSeries(this.timeObject)
					this.$dialogMethod.closeLoading()
				},respon => {
					this.$dialogMethod.closeLoading();
					this.$message({
						message: respon,
						type: 'error'
					});
				})
			},
			setSeries(timeObject) {
				var nl = []
				var fromnameList = this.nowVariableNames
				var legend = []
				var selectLegend = {}
				var count = 0
				//根据当前选中类型组和时间间隔过滤数据然后设置一下
				for (var i = 0, len = this.nowSeries.length; i < len; i++) {
					var item = this.nowSeries[i]
					if (!fromnameList.includes(item.fromName)) {
						continue
					}
					var nitem = {
						name: item.name,
						fromName: item.fromName,
						type: item.type,
						smooth: item.smooth,
						symbol: item.symbol,
						sampling: item.sampling,
						areaStyle:{},
						markPoint: {
							data: [{
								name: '最大值',
								formatter: "{b}:{c}",
								type: 'max'
							}, {
								name: '最小值',
								formatter: "{b}:{c}",
								type: 'min'
							}]
						},
						data: [],
					}
					legend.push({
						name: item.name,
						icon: 'roundRect'
					})
					selectLegend[item.name] = count++ < 6 ? true : false
					var list = []
					for (var j = 0, lens = item.data.length; j < lens; j++) {
						if (timeObject.hasOwnProperty(item.data[j][0])) {
							var temp = item.data[j]
							if (isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
								temp = undefined
							}
							list.push(temp)
						}
					}
					var resultList = []
					for (var j = 1, len1 = list.length; j < len1; j++) {
						var item = list[j]
						var last = list[j - 1]
						if (this.$historyTools.isNull(last[1]) || this.$historyTools.isNull(item[1])) {
							//任意一个无值则无法计算
							resultList.push([item[0], undefined])
						} else if (last[1] == 0) {
							//为0无法计算
							resultList.push([item[0], undefined])
						} else {
							resultList.push([item[0], cutDigital((item[1] - last[1]) / last[1] * 100)])
						}
					}
					nitem.data = resultList
					nl.push(nitem)
				}
				var chart = this.$refs.vchart
				var options = chart.getOptions()
				options.series = nl
				options.legend.data = legend
				options.legend.selected = selectLegend
				//如果数量太多就控制一下缩放
				if (Object.keys(this.timeObject).length > 144 && (options.dataZoom[0].end - options.dataZoom[0].start > 20)) {
					options.dataZoom[0].start = 0
					options.dataZoom[0].end = 10
					options.dataZoom[1].start = 0
					options.dataZoom[1].end = 10
				}
				options.title.text = this.nowDevice.name
				chart.setData(options, true)
			},
			selectInterval(interval) {
				this.timeInterval = interval
			}
		}
	}
</script>

<style scoped>
	.buttonLine {
		/* margin-top: 50px; */
	}
	.monthReportBody {
		width: 100%;
		height: 100%;
		display: flex;
	}

	.monreportLeft {
		height: 99%;
	}

	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
		/* padding-bottom: 100px; */
	}
	.historyAnalysisBody{
		width: 100%;
		display: flex !important;
		/* align-items: center; */
		justify-content: space-between;
	}
</style>
